import type { Messages } from '@/lib/i18n/messages/en'

export const vi: Messages = {
  'error.NOT_FOUND': 'Không tìm thấy.',
  'error.METHOD_NOT_ALLOWED': 'Thao tác này không được phép ở đây.',
  'error.RATE_LIMITED': 'Bạn thử quá nhiều lần. Vui lòng thử lại sau {wait}.',
  'error.BAD_REQUEST': 'Yêu cầu không hợp lệ.',
  'error.UNAUTHORIZED': 'Vui lòng đăng nhập để tiếp tục.',
  'error.INVALID_CREDENTIALS': 'Sai thông tin đăng nhập hoặc mật khẩu.',
  'error.CSRF_MISMATCH': 'Phiên làm việc đã hết hạn. Vui lòng thử lại.',
  'error.INVALID_PHONE': 'Vui lòng nhập số điện thoại hợp lệ.',
  'error.INVALID_EMAIL': 'Vui lòng nhập địa chỉ email hợp lệ.',
  'error.PASSWORD_TOO_SHORT': 'Mật khẩu phải có ít nhất {min} ký tự (bạn đã nhập {length}).',
  'error.PASSWORD_TOO_LONG': 'Mật khẩu chỉ được tối đa {max} ký tự.',
  'error.PASSWORD_TOO_COMMON': 'Mật khẩu này quá phổ biến. Vui lòng chọn mật khẩu khác.',
  'error.VERIFICATION_INVALID': 'Mã xác nhận không đúng.',
  'error.VERIFICATION_EXPIRED': 'Mã xác nhận đã hết hạn. Vui lòng yêu cầu mã mới.',
  'error.IDENTIFIER_ALREADY_HELD': 'Tài khoản này đã dùng thông tin này.',
  'error.LAST_IDENTIFIER': 'Không thể xóa phương thức đăng nhập duy nhất.',
  'error.DELETE_BLOCKED': 'Hiện không thể xóa tài khoản này: {reason}.',
  'error.SLUG_RESERVED': 'Tên URL này đã được hệ thống dành riêng. Vui lòng chọn tên khác.',
  'error.SLUG_TAKEN': 'Tên URL này đã được sử dụng. Vui lòng chọn tên khác.',
  'error.ACCOUNT_NOT_FOUND': 'Không tìm thấy tài khoản với số điện thoại hoặc email này.',
  'error.FORBIDDEN': 'Bạn không có quyền thực hiện thao tác này.',
  'error.EMAIL_TAKEN': 'Email này đã được một tài khoản khác sử dụng.',
  'error.LAST_ADMIN': 'Không thể gỡ quyền quản trị của quản trị viên cuối cùng.',
  'error.ROLE_NOT_MANAGEABLE': 'Bạn chỉ có thể quản lý các vai trò thấp hơn vai trò của mình.',
  'error.BRANCH_REQUIRED': 'Chọn ít nhất một chi nhánh cho vai trò này.',
  'error.IMAGE_TOO_LARGE': 'Ảnh quá lớn. Chọn ảnh dưới {max_mb} MB.',
  'error.INVALID_IMAGE': 'Tệp này không phải ảnh dùng được. Hãy dùng ảnh JPEG, PNG hoặc WebP.',
  'error.MISSING_MAIN_LANGUAGE': 'Hãy điền nội dung bằng ngôn ngữ chính của nhà hàng.',
  'error.INVALID_PRICE': 'Nhập giá từ 0 đến {max}, tối đa {max_decimals} chữ số thập phân.',
  'error.CATEGORY_NOT_EMPTY': 'Hãy chuyển hoặc xóa {items} món trong danh mục này trước.',
  'error.IMAGE_NOT_FOUND': 'Ảnh này không còn nữa. Hãy tải lên lại.',
  'error.INVALID_STOCK': 'Nhập số nguyên từ 0 đến {max}.',
  'error.MENU_PRICES_NOT_REPRESENTABLE':
    '{items} giá món không thể hiện chính xác bằng {currency}. Hãy sửa các giá đó trước, hoặc chọn loại tiền khác.',
  'error.ORDERING_CLOSED': 'Chi nhánh này hiện không nhận đơn.',
  'error.ORDER_PIN_INVALID': 'Mã PIN thiếu hoặc sai. Hãy hỏi nhân viên.',
  'error.ACTIVE_ORDER_CAP': 'Bạn đang có {cap} đơn đang xử lý ở đây. Hãy đợi một đơn hoàn tất.',
  'error.TABLE_NOT_FOUND': 'Mã QR của bàn này không còn hiệu lực. Hãy hỏi nhân viên lấy mã mới.',
  'error.ITEM_UNAVAILABLE': 'Một món trong giỏ không còn phục vụ. Hãy bỏ món đó và thử lại.',
  'error.INSUFFICIENT_STOCK': 'Một món trong giỏ không còn đủ số lượng. Hãy giảm số lượng và thử lại.',
  'error.INVALID_QUANTITY': 'Số lượng phải là bội số của {step}, tối đa {max}.',
  'error.LINE_NOTE_TOO_LONG': 'Ghi chú cho một món dài quá {max} ký tự. Rút ngắn rồi thử lại.',
  'error.SESSION_CLOSED': 'Phiên của bàn này vừa được đóng. Hãy quét lại mã QR.',
  'error.IDEMPOTENCY_KEY_TAKEN': 'Đơn này đã được gửi từ nơi khác. Hãy tải lại trang và thử lại.',
  'error.ORDER_NOT_CANCELABLE': 'Đơn này không thể hủy được nữa.',
  'error.ORDER_MOVED': 'Đơn này đã chuyển trạng thái rồi.',
  'error.SESSION_HAS_ACTIVE_ORDERS': 'Phiên này còn {count} đơn đang xử lý.',
  'error.TABLE_BUSY': 'Bàn {table_name} đang có phiên mở.',
  'error.INVALID_RETURN': 'Nhập bội số của {step}, tối đa {remaining}.',
  'error.INVALID_REAL_WEIGHT': 'Nhập cân nặng từ {min} đến {max}, theo bước {step}.',
  'error.INVALID_TABLE_NAME': 'Nhập tên bàn từ 1 đến {max} ký tự.',
  'error.TABLE_NAME_TAKEN': 'Một bàn khác trong chi nhánh đã dùng tên này.',
  'error.TABLE_IN_USE': 'Bàn này đang có phiên mở. Hãy đóng phiên trước khi xóa bàn.',
  'error.INVALID_EXPIRY_MINUTES': 'Nhập từ 1 đến {max} phút.',
  'error.INVALID_ACTIVE_ORDER_CAP': 'Nhập từ 1 đến {max} đơn.',
  'error.INVALID_ORDER_PIN': 'Nhập mã PIN từ 1 đến {max} ký tự.',
  'error.FEEDBACK_ALREADY_SENT': 'Đơn này đã có góp ý.',
  'error.FEEDBACK_DAILY_CAP': 'Bạn đã gửi {max} góp ý trong ngày qua. Vui lòng thử lại sau {wait}.',
  'error.INVALID_FEEDBACK_MESSAGE': 'Viết từ 1 đến {max} ký tự.',
  'error.RESTAURANT_DEACTIVATED': 'Nhà hàng này đã ngừng hoạt động. Hãy liên hệ Romi.',
  'error.RESTAURANT_CAP_REACHED': 'Tài khoản của bạn đã có một nhà hàng. Hãy liên hệ Romi để thêm nhà hàng khác.',
  'error.RESTAURANT_ACTIVE': 'Nhà hàng vẫn đang hoạt động. Hãy ngừng hoạt động trước.',
  'error.RESTAURANT_ON_HOLD': 'Nhà hàng đang được giữ đến {until}.',
  'error.SLUG_MISMATCH': 'Tên URL không khớp với nhà hàng này.',
  'error.BRANCH_CLOSED': 'Chi nhánh này đã ngừng hoạt động.',
  'error.INTERNAL': 'Đã xảy ra lỗi. Vui lòng thử lại.',
  'deleteReason.last_admin': 'đây là quản trị viên nền tảng cuối cùng',
  'deleteReason.superuser': 'tài khoản đang sở hữu một nhà hàng',
  'deleteReason.active_orders': 'tài khoản còn đơn hàng đang xử lý',
  'deleteReason.open_session': 'tài khoản còn phiên bàn đang mở',
  'deleteReason.self': 'đây là tài khoản của chính bạn',
  'duration.seconds': '{n} giây',
  'duration.minutes': '{n} phút',
  'duration.hours': '{n} giờ',
  'app.name': 'Romi',
  'app.platform': 'Nền tảng Romi',
  'notFound.title': 'Không tìm thấy trang',
  'notFound.home': 'Về trang chủ',
  'theme.label': 'Giao diện',
  'theme.system': 'Theo hệ thống',
  'theme.light': 'Sáng',
  'theme.dark': 'Tối',
  'language.label': 'Ngôn ngữ',
  'nav.label': 'Điều hướng chính',
  'nav.restaurants': 'Nhà hàng',
  'nav.users': 'Người dùng nền tảng',
  'nav.myRestaurants': 'Nhà hàng của tôi',
  'nav.settings': 'Cài đặt',
  'nav.accounts': 'Tài khoản',
  'nav.menu': 'Thực đơn',
  'nav.branches': 'Chi nhánh',
  'nav.manageRestaurant': 'Quản lý nhà hàng',
  'nav.branchMenu': 'Thực đơn chi nhánh',
  'nav.tables': 'Bàn',
  'nav.branchSettings': 'Cài đặt chi nhánh',
  'nav.branchInfo': 'Thông tin chi nhánh',
  'nav.staff': 'Nhân viên',
  'nav.queue': 'Hàng đợi',
  'nav.sessions': 'Phiên bàn',
  'nav.createOrder': 'Tạo đơn',
  'nav.search': 'Tìm kiếm',
  'nav.statistics': 'Thống kê',
  'nav.otp': 'Yêu cầu OTP',
  'nav.systemLog': 'Nhật ký hệ thống',
  'nav.cleanup': 'Dọn dữ liệu',
  'nav.more': 'Thêm',
  'nav.account': 'Menu tài khoản',
  'nav.collapse': 'Thu gọn thanh bên',
  'nav.expand': 'Mở rộng thanh bên',
  'nav.group.operation': 'Vận hành',
  'nav.group.branch': 'Quản lý chi nhánh',
  'nav.group.restaurant': 'Quản lý nhà hàng',
  'nav.group.platform': 'Nền tảng',
  'auth.login': 'Đăng nhập',
  'auth.logout': 'Đăng xuất',
  'auth.platformLogin': 'Đăng nhập nền tảng',
  'auth.identifierToggle': 'Điện thoại hoặc email',
  'auth.phone': 'Điện thoại',
  'auth.email': 'Email',
  'auth.nation': 'Quốc gia',
  'auth.phoneNumber': 'Số điện thoại',
  'auth.password': 'Mật khẩu',
  'auth.showPassword': 'Hiện mật khẩu',
  'auth.register': 'Đăng ký',
  'auth.registerIntro': 'Nhập số điện thoại hoặc email, chúng tôi sẽ gửi mã xác nhận cho bạn.',
  'auth.sendCode': 'Gửi mã',
  'auth.haveCode': 'Tôi đã có mã',
  'auth.verifyTitle': 'Xác nhận và đặt mật khẩu',
  'auth.code': 'Mã xác nhận',
  'auth.codeSentEmail': 'Nhập mã đã gửi tới email của bạn. Mã có hiệu lực trong 10 phút; yêu cầu mã mới sẽ thay thế mã cũ.',
  'auth.codeSentPhone':
    'Nhân viên vận hành sẽ nhắn tin mã cho bạn — việc này có thể mất một lúc, và chưa có gì để nhập cho đến khi mã đến. Bạn không cần yêu cầu lại.',
  'auth.codeSentToPhone': 'Đã gửi mã tới điện thoại của bạn.',
  'auth.codeSentToEmail': 'Đã gửi mã tới email của bạn.',
  'auth.resetCodeSentToPhone': 'Nếu khớp với một tài khoản, mã đã được gửi tới điện thoại của bạn.',
  'auth.resetCodeSentToEmail': 'Nếu khớp với một tài khoản, mã đã được gửi tới email của bạn.',
  'auth.expiresIn': 'Hết hạn sau {time}.',
  'auth.codeExpired': 'Mã đó đã hết hạn.',
  'auth.didntGetIt': 'Chưa nhận được mã?',
  'auth.useEmailInstead': 'Dùng email thay thế',
  'auth.smsLimitNotice':
    'Số này đã hết lượt nhận SMS hôm nay. Nhân viên vận hành có thể nhắn mã thủ công cho bạn — việc này có thể mất một lúc.',
  'auth.askOperator': 'Nhờ nhân viên vận hành nhắn mã',
  'auth.noMoreCodes': 'Hôm nay không thể gửi thêm mã cho thông tin này.',
  'auth.smsUnsupportedHint':
    'SMS chưa hỗ trợ quốc gia này. Để nhận mã ngay, hãy dùng email hoặc số điện thoại Việt Nam.',
  'auth.firstName': 'Tên',
  'auth.lastName': 'Họ',
  'auth.resendCode': 'Gửi mã mới',
  'auth.codeRequested': 'Đã yêu cầu mã mới.',
  'auth.createAccount': 'Tạo tài khoản',
  'auth.forgotPassword': 'Quên mật khẩu',
  'auth.forgotIntro':
    'Nhập số điện thoại hoặc email của bạn. Nếu khớp với một tài khoản, chúng tôi sẽ gửi cho bạn mã đặt lại mật khẩu.',
  'auth.forgotIntroEmail':
    'Nhập email của bạn. Nếu khớp với một tài khoản, chúng tôi sẽ gửi cho bạn mã đặt lại mật khẩu.',
  'auth.resetTitle': 'Đặt lại mật khẩu',
  'auth.resetCodeSentEmail':
    'Nếu khớp với một tài khoản, mã đã được gửi tới email của bạn. Mã có hiệu lực trong 10 phút; yêu cầu mã mới sẽ thay thế mã cũ.',
  'auth.resetCodeSentPhone':
    'Nếu khớp với một tài khoản, nhân viên vận hành sẽ nhắn tin mã cho bạn — việc này có thể mất một lúc, và chưa có gì để nhập cho đến khi mã đến. Bạn không cần yêu cầu lại.',
  'auth.newPassword': 'Mật khẩu mới',
  'auth.currentPassword': 'Mật khẩu hiện tại',
  'auth.passwordRuleLength': 'Ít nhất {min} ký tự',
  'auth.passwordRuleCommon': 'Không phải mật khẩu phổ biến',
  'auth.passwordRuleMax': 'Tối đa {max} ký tự',
  'auth.resetPassword': 'Đặt lại mật khẩu',
  'profile.title': 'Hồ sơ',
  'profile.detailsTitle': 'Tên & ngôn ngữ',
  'profile.saved': 'Đã lưu.',
  'profile.passwordTitle': 'Đổi mật khẩu',
  'profile.passwordChanged': 'Đã đổi mật khẩu. Các thiết bị khác của bạn đã bị đăng xuất.',
  'profile.loginTitle': 'Phương thức đăng nhập',
  'profile.notSet': 'Chưa đặt',
  'profile.add': 'Thêm',
  'profile.change': 'Thay đổi',
  'profile.remove': 'Xóa',
  'profile.reenterHint': 'Nhập mật khẩu hiện tại để xác nhận.',
  'profile.pendingIdentifier': 'Đang xác nhận {identifier}.',
  'profile.verify': 'Xác nhận',
  'profile.deleteTitle': 'Xóa tài khoản',
  'profile.deleteIntro': 'Xóa tài khoản và toàn bộ dữ liệu cá nhân của bạn. Không thể hoàn tác.',
  'profile.deleteConfirm': 'Xóa tài khoản của tôi',
  'slug.empty': 'Vui lòng nhập tên URL.',
  'slug.tooLong': 'Tối đa {max} ký tự.',
  'slug.forbiddenChar': 'Chỉ dùng chữ thường không dấu, chữ số và dấu gạch ngang.',
  'slug.edgeHyphen': 'Không được bắt đầu hoặc kết thúc bằng dấu gạch ngang.',
  'slug.doubleHyphen': 'Không được có hai dấu gạch ngang liền nhau.',
  'slug.checking': 'Đang kiểm tra…',
  'slug.available': 'Có thể dùng.',
  'restaurants.title': 'Nhà hàng',
  'restaurants.create': 'Tạo nhà hàng',
  'restaurants.empty': 'Chưa có nhà hàng nào.',
  'restaurants.pager': 'Phân trang nhà hàng',
  'restaurants.branchCount': '{count} chi nhánh',
  'restaurants.superuserIs': 'Chủ nhà hàng: {name}',
  'restaurants.active': 'Đang hoạt động',
  'restaurants.deactivated': 'Đã ngừng hoạt động',
  'restaurants.noSuperuser': 'Chưa có chủ nhà hàng',
  'restaurants.noSuperuserHint': 'Chưa ai có thể quản lý nhà hàng này cho đến khi liên kết tài khoản chủ.',
  'restaurants.restaurantSection': 'Nhà hàng',
  'restaurants.name': 'Tên',
  'restaurants.slug': 'Tên URL',
  'restaurants.slugHint': 'Chữ thường không dấu, chữ số và dấu gạch ngang. Đây là địa chỉ web của nhà hàng và không thể đổi sau này.',
  'restaurants.color': 'Màu',
  'restaurants.mainLanguage': 'Ngôn ngữ chính',
  'restaurants.secondaryLanguages': 'Ngôn ngữ phụ',
  'restaurants.createdAt': 'Ngày tạo',
  'restaurants.firstBranch': 'Chi nhánh đầu tiên',
  'restaurants.branches': 'Chi nhánh',
  'restaurants.branchName': 'Tên chi nhánh',
  'restaurants.branchSlug': 'Tên URL chi nhánh',
  'restaurants.branchSlugHint': 'Không trùng trong cùng nhà hàng; là một phần địa chỉ web của chi nhánh.',
  'restaurants.currencyHint': 'Theo múi giờ cho đến khi bạn tự chọn.',
  'restaurants.timezone': 'Múi giờ',
  'restaurants.currency': 'Tiền tệ',
  'restaurants.addBranch': 'Thêm chi nhánh',
  'restaurants.branchAdded': 'Đã thêm chi nhánh {name}.',
  'restaurants.superuser': 'Chủ nhà hàng',
  'restaurants.orders': 'Đơn hàng',
  'restaurants.superuserHint': 'Số điện thoại hoặc email chính xác của tài khoản Romi mà chủ nhà hàng đã đăng ký.',
  'restaurants.accountFound': 'Đã tìm thấy tài khoản',
  'restaurants.searchSuperuserFirst': 'Hãy tìm tài khoản chủ nhà hàng trước, hoặc xóa trống ô nhập.',
  'restaurants.linkSuperuser': 'Liên kết chủ nhà hàng',
  'restaurants.changeSuperuser': 'Đổi chủ nhà hàng',
  'restaurants.superuserChanged': 'Đã cập nhật chủ nhà hàng.',
  'restaurants.deactivate': 'Ngừng hoạt động',
  'restaurants.reactivate': 'Kích hoạt lại',
  'restaurants.confirmDeactivate': 'Xác nhận ngừng hoạt động',
  'restaurants.confirmDeactivateOf': 'Xác nhận ngừng hoạt động {name}',
  'restaurants.notices': 'Thông báo',
  'restaurants.noticeHint': 'Thông báo theo mẫu tới mọi quản lý và chủ nhà hàng. Ngừng hoạt động và kích hoạt lại được gửi bởi các nút phía trên.',
  'restaurants.noticeTemplate': 'Mẫu',
  'restaurants.noticeAmount': 'Số tiền',
  'restaurants.noticeAmountHint': 'Dạng chữ, ví dụ 300.000 VND.',
  'restaurants.noticeDueDate': 'Hạn thanh toán',
  'restaurants.noticeDeactivateOn': 'Ngừng hoạt động vào',
  'restaurants.noticeRemoveOn': 'Xóa vào',
  'restaurants.sendNotice': 'Gửi thông báo',
  'restaurants.confirmSend': 'Xác nhận gửi',
  'restaurants.noticeGoesTo': 'Mọi quản lý và chủ nhà hàng của {name} sẽ thấy thông báo này trong ứng dụng.',
  'restaurants.noticeGoesToEmail': 'Mọi quản lý và chủ nhà hàng của {name} sẽ thấy thông báo này trong ứng dụng và nhận qua email.',
  'restaurants.noticeSent': 'Đã gửi thông báo tới {recipients} tài khoản, {emails} qua email.',
  'restaurants.filter': 'Hiển thị',
  'restaurants.filterAll': 'Tất cả',
  'restaurants.filterDeletable': 'Chờ xóa',
  'restaurants.emptyDeletable': 'Không có nhà hàng chờ xóa: mọi nhà hàng đã ngừng hoạt động đều đang được giữ, hoặc chưa có nhà hàng nào ngừng hoạt động.',
  'restaurants.lastOrder': 'Đơn cuối {date}',
  'restaurants.noOrders': 'Chưa có đơn',
  'restaurants.deactivatedOn': 'Ngừng hoạt động {date}',
  'restaurants.hold': 'Giữ dữ liệu',
  'restaurants.holdHint': 'Giữ nhà hàng ngoài danh sách chờ xóa cho đến khi qua ngày này. Ghi lại ai yêu cầu và vì sao.',
  'restaurants.heldUntil': 'Giữ đến {date}',
  'restaurants.noHold': 'Không giữ',
  'restaurants.holdUntil': 'Giữ đến',
  'restaurants.holdNote': 'Ghi chú',
  'restaurants.saveHold': 'Lưu',
  'restaurants.clearHold': 'Bỏ giữ',
  'restaurants.holdSaved': 'Đã lưu.',
  'restaurants.holdCleared': 'Đã bỏ giữ.',
  'restaurants.danger': 'Xóa nhà hàng',
  'restaurants.deleteHint': 'Xóa nhà hàng và toàn bộ dữ liệu: chi nhánh, thực đơn, hình ảnh, bàn, đơn hàng, lịch sử. Tài khoản được giữ lại. Không thể hoàn tác.',
  'restaurants.deleteNeedsDeactivation': 'Chỉ xóa được nhà hàng đã ngừng hoạt động. Hãy ngừng hoạt động trước.',
  'restaurants.deleteHeld': 'Đang giữ đến {date}.',
  'restaurants.deleteHeldNote': 'Đang giữ đến {date}: {note}',
  'restaurants.checkDelete': 'Kiểm tra dữ liệu sẽ bị xóa',
  'restaurants.deleteSlugLabel': 'Tên URL',
  'restaurants.deleteTypeSlug': 'Nhập {slug} để xác nhận.',
  'restaurants.delete': 'Xóa nhà hàng',
  'restaurants.confirmDelete': 'Xóa',
  'restaurants.confirmDeleteOf': 'Xác nhận xóa {name}',
  'restaurants.confirmDeleteText': '{rows} dòng dữ liệu sẽ bị xóa và không thể khôi phục.',
  'notice.template.payment_reminder': 'Nhắc thanh toán',
  'notice.template.deactivation_warning': 'Cảnh báo ngừng hoạt động',
  'notice.template.deactivated': 'Đã ngừng hoạt động',
  'notice.template.payment_received': 'Đã nhận thanh toán',
  'notice.template.reactivated': 'Đã kích hoạt lại',
  'notice.template.removal_notice': 'Thông báo xóa dữ liệu',
  'users.title': 'Người dùng nền tảng',
  'users.create': 'Tạo người dùng',
  'users.createIntro':
    'Không đặt mật khẩu ở đây. Người dùng tự đặt mật khẩu qua Quên mật khẩu trên trang đăng nhập nền tảng.',
  'users.empty': 'Chưa có người dùng nền tảng nào.',
  'users.pager': 'Phân trang người dùng nền tảng',
  'users.admin': 'Quản trị viên',
  'users.you': 'Bạn',
  'users.isAdmin': 'Quản trị viên nền tảng',
  'users.isAdminHint': 'Quản trị viên có thể quản lý người dùng nền tảng. Những người khác quản lý nhà hàng và yêu cầu OTP.',
  'users.createdAt': 'Ngày tạo',
  'users.created': 'Đã tạo tài khoản cho {email}.',
  'users.firstLoginTitle': 'Đăng nhập lần đầu',
  'users.firstLoginIntro':
    'Chưa gửi email nào. Hãy bảo {email} mở trang bên dưới và dùng Quên mật khẩu để tự đặt mật khẩu. Trang này cũng dùng để khôi phục mật khẩu đã quên.',
  'users.openUser': 'Mở người dùng',
  'users.createAnother': 'Tạo người khác',
  'users.deleteTitle': 'Xóa tài khoản',
  'users.deleteIntro': 'Gỡ quyền truy cập và dữ liệu cá nhân của người này. Không thể hoàn tác.',
  'users.deleteSelfHint': 'Để xóa tài khoản của chính bạn, hãy dùng trang hồ sơ.',
  'users.delete': 'Xóa',
  'users.confirmDelete': 'Xác nhận xóa',
  'users.confirmDeleteOf': 'Xác nhận xóa {name}',
  'users.adminOnly': 'Chỉ quản trị viên nền tảng mới có thể quản lý người dùng nền tảng.',
  'otp.title': 'Yêu cầu OTP',
  'otp.tabs': 'Các chế độ xem yêu cầu OTP',
  'otp.pending': 'Đang chờ',
  'otp.sent': 'Đã gửi',
  'otp.emptyPending': 'Không có yêu cầu nào đang chờ.',
  'otp.emptySent': 'Chưa gửi mã nào.',
  'otp.pager': 'Phân trang yêu cầu OTP',
  'otp.purpose.verify_phone': 'Đăng ký',
  'otp.purpose.reset_password': 'Đặt lại mật khẩu',
  'otp.requestedAt': 'Yêu cầu lúc {time}',
  'otp.generate': 'Tạo mã',
  'otp.generateFor': 'Tạo mã cho {identifier}',
  'otp.codeTitle': 'Mã cho {identifier}',
  'otp.codeIntro': 'Nhắn mã này tới số điện thoại. Mã chỉ hiển thị một lần ở đây và có hiệu lực đến {expires}.',
  'otp.copy': 'Sao chép mã',
  'otp.copied': 'Đã sao chép',
  'otp.done': 'Xong',
  'otp.gone': 'Yêu cầu này không còn đang chờ — có thể người khác đã xử lý, hoặc người dùng đã yêu cầu lại.',
  'otp.sentBy': '{name} đã gửi lúc {time}',
  'otp.sentAt': 'Đã gửi lúc {time}',
  'otp.state.used': 'Đã dùng',
  'otp.state.expired': 'Hết hạn',
  'otp.state.active': 'Còn hiệu lực',
  'systemLog.title': 'Nhật ký hệ thống',
  'systemLog.intro': 'Cảnh báo và lỗi máy chủ đã ghi lại, mới nhất ở trên.',
  'systemLog.tabs': 'Chế độ xem nhật ký hệ thống',
  'systemLog.errors': 'Lỗi',
  'systemLog.all': 'Tất cả',
  'systemLog.emptyErrors': 'Chưa ghi nhận lỗi nào.',
  'systemLog.emptyAll': 'Chưa có gì được ghi lại.',
  'systemLog.pager': 'Phân trang nhật ký hệ thống',
  'systemLog.level.error': 'Lỗi',
  'systemLog.level.warn': 'Cảnh báo',
  'systemLog.details': 'Chi tiết',
  'cleanup.title': 'Dọn dữ liệu',
  'cleanup.intro':
    'Dữ liệu cũ tích lũy trên mọi nhà hàng. Chọn ngày cho từng nhóm, kiểm tra những gì sẽ bị xóa, rồi dọn. Không xóa gì khi chưa kiểm tra.',
  'cleanup.vacuumNote':
    'Dung lượng là ước tính. Postgres dùng lại chỗ trống cho dữ liệu mới thay vì thu nhỏ ổ đĩa, nên con số cho biết phần nào ngừng tăng.',
  'cleanup.before': 'Xóa dữ liệu cũ hơn',
  'cleanup.check': 'Kiểm tra',
  'cleanup.run': 'Dọn dữ liệu',
  'cleanup.confirm': 'Đồng ý, dọn',
  'cleanup.confirmText': 'Xóa {rows} dòng cũ hơn {before}? Không thể hoàn tác.',
  'cleanup.progress': 'Đã xóa {rows} dòng…',
  'cleanup.finished': 'Đã dọn xong.',
  'cleanup.nothing': 'Không có gì để dọn trước mốc này.',
  'cleanup.mustBePast': 'Ngày phải ở quá khứ.',
  'cleanup.adminOnly': 'Chỉ quản trị viên nền tảng mới được dọn dữ liệu.',
  'cleanup.col.table': 'Bảng',
  'cleanup.col.rows': 'Số dòng',
  'cleanup.col.bytes': 'Dung lượng ước tính',
  'cleanup.group.orders': 'Đơn hàng',
  'cleanup.group.system_log': 'Nhật ký hệ thống',
  'cleanup.group.notifications': 'Thông báo',
  'cleanup.group.verification_codes': 'Mã xác minh',
  'cleanup.group.audit_log': 'Nhật ký thay đổi',
  'cleanup.group.feedback': 'Góp ý',
  'cleanup.describe.orders':
    'Đơn đã hoàn tất, đã hủy và hết hạn cùng các món, phiên bàn đã đóng không còn đơn nào tham chiếu, và bộ đếm số đơn theo ngày. Đơn đang xử lý và phiên đang mở luôn được giữ.',
  'cleanup.describe.system_log': 'Mọi cảnh báo và lỗi cũ hơn ngày đã chọn.',
  'cleanup.describe.notifications': 'Thông báo đã đọc cũ hơn ngày đã chọn. Thông báo chưa đọc được giữ.',
  'cleanup.describe.verification_codes':
    'Mã đã dùng, hết hạn và bị khóa cũ hơn ngày đã chọn. Yêu cầu đang chờ cấp mã thủ công được giữ.',
  'cleanup.describe.audit_log': 'Mọi dòng nhật ký thay đổi cũ hơn ngày đã chọn. Nhà hàng sẽ mất lịch sử thay đổi trước đó.',
  'cleanup.describe.feedback': 'Mọi góp ý cũ hơn ngày đã chọn, gửi cho nhà hàng lẫn cho Romi.',
  'cleanup.ordersWarning': 'Thống kê và lịch sử đơn của khách trước mốc này sẽ mất cùng đơn hàng.',
  'cleanup.table.orders': 'Đơn hàng',
  'cleanup.table.order_lines': 'Món trong đơn',
  'cleanup.table.dining_sessions': 'Phiên bàn',
  'cleanup.table.order_counters': 'Bộ đếm số đơn',
  'cleanup.table.system_log': 'Dòng nhật ký hệ thống',
  'cleanup.table.notifications': 'Thông báo',
  'cleanup.table.verification_codes': 'Mã xác minh',
  'cleanup.table.audit_log': 'Dòng nhật ký thay đổi',
  'cleanup.table.feedback': 'Góp ý',
  'cleanup.table.branches': 'Chi nhánh',
  'cleanup.table.restaurant_roles': 'Vai trò',
  'cleanup.table.role_branches': 'Phân công chi nhánh',
  'cleanup.table.menu_categories': 'Danh mục thực đơn',
  'cleanup.table.menu_items': 'Món',
  'cleanup.table.branch_menu_items': 'Tùy chỉnh thực đơn theo chi nhánh',
  'cleanup.table.dining_tables': 'Bàn',
  'cleanup.table.images': 'Hình ảnh',
  'cleanup.table.restaurants': 'Nhà hàng',
  'nav.auditLog': 'Nhật ký thay đổi',
  'nav.feedback': 'Góp ý',
  'audit.title': 'Nhật ký thay đổi',
  'audit.intro': 'Ai đã thay đổi gì, từ giá trị nào sang giá trị nào. Mới nhất ở trên.',
  'audit.managerOnly': 'Chỉ quản lý nhà hàng và chủ nhà hàng mới được xem nhật ký thay đổi.',
  'audit.empty': 'Chưa ghi nhận thay đổi nào.',
  'audit.pager': 'Phân trang nhật ký thay đổi',
  'audit.filter.branch': 'Chi nhánh',
  'audit.filter.allBranches': 'Mọi chi nhánh',
  'audit.filter.entity': 'Đối tượng thay đổi',
  'audit.filter.allEntities': 'Tất cả',
  'audit.filter.from': 'Từ ngày',
  'audit.filter.to': 'Đến ngày',
  'audit.entity.restaurant': 'Nhà hàng',
  'audit.entity.branch': 'Chi nhánh',
  'audit.entity.menu_category': 'Nhóm món',
  'audit.entity.menu_item': 'Món ăn',
  'audit.entity.table': 'Bàn',
  'audit.entity.account': 'Tài khoản',
  'audit.entity.order': 'Đơn hàng',
  'audit.entity.session': 'Phiên bàn',
  'audit.entity.platform_user': 'Người dùng nền tảng',
  'audit.entity.cleanup': 'Dọn dữ liệu',
  'audit.changes': 'Thay đổi',
  'audit.col.field': 'Trường',
  'audit.col.from': 'Trước',
  'audit.col.to': 'Sau',
  'audit.actor.platform': 'Nền tảng',
  'audit.actor.admin': 'Quản trị',
  'audit.actor.customer': 'Khách hàng',
  'audit.actor.unknown': 'Tài khoản không rõ',
  'audit.none': 'không có',
  'audit.yes': 'có',
  'audit.no': 'không',
  'audit.pin.set': 'đã đặt',
  'audit.pin.unset': 'chưa đặt',
  'audit.pin.changed': 'đã đổi',
  'audit.mode.open': 'Mở',
  'audit.mode.login': 'Đăng nhập',
  'audit.mode.closed': 'Đóng',
  'audit.unknown': 'Thay đổi: {key}',
  'audit.history.title': 'Lịch sử',
  'audit.history.empty': 'Chưa có thay đổi nào.',
  'audit.platform.title': 'Nhật ký thay đổi nền tảng',
  'audit.platform.intro': 'Những gì người dùng nền tảng đã làm với nhà hàng và tài khoản. Mới nhất ở trên.',
  'audit.platform.adminOnly': 'Chỉ quản trị viên nền tảng mới được xem nhật ký này.',
  'audit.platform.filter.restaurant': 'Nhà hàng',
  'audit.platform.allRestaurants': 'Mọi nhà hàng',
  'feedback.title': 'Góp ý',
  'feedback.intro': 'Khách hàng viết gì về nhà hàng, từ đơn hàng và trang giới thiệu. Mới nhất trước.',
  'feedback.managerOnly': 'Chỉ quản lý và chủ nhà hàng mới đọc được góp ý.',
  'feedback.empty': 'Chưa có góp ý nào.',
  'feedback.pager': 'Các trang góp ý',
  'feedback.filter.branch': 'Chi nhánh',
  'feedback.filter.allBranches': 'Mọi chi nhánh',
  'feedback.platform.title': 'Góp ý về Romi',
  'feedback.platform.intro': 'Người dùng nhà hàng muốn sửa hay thêm gì. Mới nhất trước.',
  'feedback.author.anonymous': 'Khách ẩn danh',
  'feedback.author.deleted': 'Tài khoản đã xóa',
  'feedback.author.unnamed': 'Tài khoản chưa đặt tên',
  'feedback.about.order': 'Đơn #{number}',
  'feedback.about.branch': 'Chi nhánh {name}',
  'feedback.about.restaurant': 'Nhà hàng',
  'feedback.about.app': 'Về Romi',
  'feedback.about.page': 'Từ {path}',
  'feedback.form.label': 'Nội dung góp ý',
  'feedback.form.count': '{count} / {max}',
  'feedback.form.send': 'Gửi góp ý',
  'feedback.form.sentAt': 'Đã gửi {time}',
  'feedback.form.thanks': 'Cảm ơn, góp ý của bạn đã được gửi.',
  'feedback.order.title': 'Góp ý cho đơn này',
  'feedback.order.hint': 'Cho {restaurant} biết trải nghiệm của bạn. Mỗi đơn một góp ý.',
  'feedback.for': 'Góp ý cho {name}',
  'feedback.forRomi': 'Góp ý cho Romi',
  'audit.field.name': 'Tên',
  'audit.field.color': 'Màu',
  'audit.field.intro': 'Giới thiệu',
  'audit.field.main_language': 'Ngôn ngữ chính',
  'audit.field.secondary_languages': 'Ngôn ngữ phụ',
  'audit.field.address': 'Địa chỉ',
  'audit.field.phone': 'Điện thoại',
  'audit.field.opening_hours': 'Giờ mở cửa',
  'audit.field.announcement': 'Thông báo',
  'audit.field.ordering_mode': 'Chế độ đặt món',
  'audit.field.open_order_expiry_minutes': 'Hết hạn đơn (phút)',
  'audit.field.active_order_cap': 'Số đơn đang xử lý mỗi khách',
  'audit.field.order_pin': 'Mã PIN đặt món',
  'audit.field.delivery_address_enabled': 'Địa chỉ giao hàng',
  'audit.field.category_id': 'Nhóm món',
  'audit.field.price': 'Giá',
  'audit.field.step': 'Bước số lượng',
  'audit.field.image_id': 'Hình ảnh',
  'audit.field.available': 'Còn phục vụ',
  'audit.field.stock': 'Số lượng trong ngày',
  'audit.field.branches': 'Chi nhánh',
  'audit.field.role': 'Vai trò',
  'audit.field.returned_quantity': 'Đã trả lại',
  'audit.field.quantity': 'Số lượng',
  'audit.field.line_total': 'Thành tiền',
  'audit.field.table_name': 'Bàn',
  'audit.field.email': 'Email',
  'audit.field.first_name': 'Tên',
  'audit.field.last_name': 'Họ',
  'audit.field.is_admin': 'Quản trị',
  'audit.field.hold_until': 'Giữ đến',
  'audit.field.hold_note': 'Ghi chú giữ',
  'audit.action.restaurant.settings_updated': 'Đã cập nhật cài đặt nhà hàng',
  'audit.action.branch.info_updated': 'Đã cập nhật thông tin chi nhánh {branch}',
  'audit.action.branch.settings_updated': 'Đã cập nhật cài đặt chi nhánh {branch}',
  'audit.action.branch.opened': 'Đã mở cửa chi nhánh {branch}',
  'audit.action.branch.closed': 'Đã đóng cửa chi nhánh {branch}',
  'audit.action.menu.category_created': 'Đã thêm nhóm món {name}',
  'audit.action.menu.category_updated': 'Đã cập nhật nhóm món {name}',
  'audit.action.menu.category_deleted': 'Đã xóa nhóm món {name}',
  'audit.action.menu.categories_reordered': 'Đã sắp xếp lại các nhóm món: {names}',
  'audit.action.menu.item_created': 'Đã thêm món {name} giá {price}',
  'audit.action.menu.item_updated': 'Đã cập nhật món {name}',
  'audit.action.menu.item_deleted': 'Đã xóa món {name}',
  'audit.action.branch_menu.availability_set': 'Đã đổi tình trạng phục vụ của {name} tại chi nhánh {branch}',
  'audit.action.branch_menu.price_set': 'Đã đổi giá của {name} tại chi nhánh {branch}',
  'audit.action.role.granted': 'Đã cấp vai trò {role} cho {account}',
  'audit.action.role.changed': 'Đã đổi vai trò của {account} thành {role}',
  'audit.action.role.branches_changed': 'Đã đổi chi nhánh của {account}',
  'audit.action.role.revoked': 'Đã thu hồi vai trò {role} của {account}',
  'audit.action.table.created': 'Đã thêm bàn {table}',
  'audit.action.table.renamed': 'Đã đổi tên bàn {table}',
  'audit.action.table.deleted': 'Đã xóa bàn {table}',
  'audit.action.order.status_changed': 'Đã chuyển đơn #{order} từ {from} sang {to}',
  'audit.action.order.line_returned': 'Đã trả lại {name} trong đơn #{order}',
  'audit.action.order.real_weight_set': 'Đã nhập cân nặng thực của {name} trong đơn #{order}',
  'audit.action.session.closed': 'Đã đóng phiên tại bàn {table}',
  'audit.action.session.table_changed': 'Đã chuyển phiên {code} sang bàn khác',
  'audit.action.session.merged': 'Đã gộp phiên tại bàn {fromTable} vào phiên tại bàn {table}',
  'audit.action.restaurant.created': 'Đã tạo nhà hàng {name} với chi nhánh {branch}',
  'audit.action.restaurant.deactivated': 'Đã ngừng hoạt động nhà hàng {name}',
  'audit.action.restaurant.reactivated': 'Đã kích hoạt lại nhà hàng {name}',
  'audit.action.restaurant.superuser_changed': 'Đã đặt {account} làm chủ nhà hàng',
  'audit.action.restaurant.superuser_replaced': 'Đã đặt {account} làm chủ nhà hàng, thay cho {from}',
  'audit.action.branch.created': 'Đã thêm chi nhánh {branch}',
  'audit.action.branch.deactivated': 'Đã ngừng hoạt động chi nhánh {branch} (nền tảng)',
  'audit.action.branch.reactivated': 'Đã kích hoạt lại chi nhánh {branch} (nền tảng)',
  'audit.action.branch.closure': 'Đã ngừng hoạt động chi nhánh {branch}',
  'audit.action.branch.reopening': 'Đã kích hoạt lại chi nhánh {branch}',
  'audit.action.restaurant.notice_sent': 'Đã gửi thông báo “{template}” tới {name}, {recipients} người nhận',
  'audit.action.restaurant.hold_set': 'Đã đặt giữ dữ liệu cho {name}',
  'audit.action.restaurant.hold_cleared': 'Đã bỏ giữ dữ liệu cho {name}',
  'audit.action.restaurant.deleted': 'Đã xóa nhà hàng {name} (/{slug}): {rows}',
  'audit.action.platform_user.created': 'Đã tạo người dùng nền tảng {email}',
  'audit.action.platform_user.updated': 'Đã cập nhật người dùng nền tảng {email}',
  'audit.action.platform_user.deleted': 'Đã xóa người dùng nền tảng {email}',
  'audit.action.cleanup.ran': 'Đã dọn {group} cũ hơn {before}: {rows}',
  'notification.title': 'Thông báo',
  'notification.bell': 'Thông báo',
  'notification.bellUnread': 'Thông báo, {count} chưa đọc',
  'notification.empty': 'Chưa có thông báo nào.',
  'notification.pager': 'Các trang thông báo',
  'notification.seeAll': 'Xem tất cả',
  'notification.markAllRead': 'Đánh dấu đã đọc tất cả',
  'notification.new': 'Mới',
  'notification.identifier_claimed':
    '{channel} {identifier} của bạn đã được một tài khoản khác xác minh và không còn thuộc tài khoản của bạn. Bạn vẫn có thể đăng nhập bằng phương thức còn lại.',
  'notification.otp_requested': 'Có yêu cầu OTP mới ({purpose}) đang chờ trong hàng đợi.',
  'notification.role_granted': 'Bạn hiện là {role} tại {restaurant}.',
  'notification.role_revoked': 'Vai trò {role} của bạn tại {restaurant} đã bị gỡ.',
  'notification.feedback.restaurant': 'Có góp ý mới cho {restaurant}.',
  'notification.feedback.app': 'Có góp ý mới về Romi.',
  'notification.restaurant_created': '{creator} đã tạo nhà hàng {restaurant}.',
  'notification.someone': 'Một người dùng',
  'notification.notice.payment_reminder': 'Nhắc thanh toán cho {restaurant}: {amount}, hạn {dueDate}.',
  'notification.notice.deactivation_warning': '{restaurant} sẽ bị ngừng hoạt động vào {deactivateOn} nếu không thanh toán trước {dueDate}.',
  'notification.notice.deactivated': '{restaurant} đã bị ngừng hoạt động. Liên hệ Romi để khôi phục.',
  'notification.notice.payment_received': 'Đã nhận thanh toán {amount} cho {restaurant}. Xin cảm ơn.',
  'notification.notice.reactivated': '{restaurant} đã hoạt động trở lại.',
  'notification.notice.removal_notice': 'Dữ liệu của {restaurant} sẽ bị xóa vào {removeOn} nếu bạn không liên hệ Romi.',
  'notification.restaurant_removed': 'Nhà hàng {restaurant} và dữ liệu của nó đã bị xóa.',
  'notification.unknown': 'Thông báo: {key}',
  'role.staff': 'Nhân viên',
  'role.admin': 'Quản lý chi nhánh',
  'role.manager': 'Quản lý nhà hàng',
  'role.superuser': 'Chủ nhà hàng',
  'backOffice.title': 'Nhà hàng của tôi',
  'backOffice.branchNotInScope': 'Đây không phải chi nhánh bạn làm việc.',
  'backOffice.restaurantDeactivated': 'Nhà hàng này đã ngừng hoạt động. Hãy liên hệ Romi để kích hoạt lại.',
  'backOffice.branchClosed': 'Chi nhánh này đã ngừng hoạt động. Chỉ còn xem được thống kê.',
  'backOffice.empty': 'Bạn chưa có vai trò ở nhà hàng nào. Hãy nhờ nhà hàng cấp vai trò cho bạn.',
  'backOffice.emptyCreate': 'Bạn là chủ nhà hàng? Tự thiết lập chỉ trong một phút.',
  'backOffice.create': 'Tạo nhà hàng',
  'backOffice.createCap': 'Tài khoản của bạn đã có một nhà hàng. Hãy liên hệ Romi để thêm nhà hàng khác.',
  'backOffice.createTitle': 'Tạo nhà hàng của bạn',
  'backOffice.createIntro':
    'Bạn sẽ là chủ nhà hàng mới. Romi sẽ được thông báo và liên hệ để hỗ trợ bạn thiết lập.',
  'settings.title': 'Cài đặt nhà hàng',
  'settings.managerOnly': 'Chỉ quản lý nhà hàng và chủ nhà hàng mới được thay đổi cài đặt nhà hàng.',
  'settings.general': 'Nhà hàng',
  'settings.colorHint': 'Dùng cho nút bấm và điểm nhấn trên các trang của nhà hàng. Chữ luôn dễ đọc dù bạn chọn màu nào.',
  'settings.languagesTitle': 'Ngôn ngữ',
  'settings.mainLanguageHint':
    'Món ăn và các nội dung phải được nhập bằng ngôn ngữ chính. Ngôn ngữ phụ là phần bổ sung, không bắt buộc.',
  'settings.mainChangeTitle': 'Đổi ngôn ngữ chính sang {language}',
  'settings.mainChangeChecking': 'Đang kiểm tra nội dung nào đã có bản {language}…',
  'settings.mainChangeMissing':
    'Không có gì bị chặn. Các mục sau chưa có bản {language} và sẽ hiển thị bằng ngôn ngữ khác cho đến khi bạn bổ sung:',
  'settings.mainChangeComplete': 'Mọi nội dung đã có bản {language}.',
  'settings.missing.intro': 'Giới thiệu nhà hàng',
  'settings.missing.menuCategory': 'Danh mục: {name}',
  'settings.missing.menuItem': 'Món: {name}',
  'settings.missing.announcement': 'Thông báo của chi nhánh: {name}',
  'settings.introTitle': 'Giới thiệu',
  'settings.introHint':
    'Hiển thị trên trang nhà hàng. Khách xem bằng ngôn ngữ của họ nếu đã nhập, nếu không thì bằng ngôn ngữ chính.',
  'settings.introFor': 'Giới thiệu ({language})',
  'settings.introMain': 'Ngôn ngữ chính',
  'settings.saved': 'Đã lưu cài đặt.',
  'accounts.title': 'Tài khoản',
  'accounts.managerOnly': 'Chỉ quản lý nhà hàng và chủ nhà hàng mới được quản lý tài khoản.',
  'accounts.roleFilter': 'Hiện vai trò',
  'accounts.empty': 'Chưa có tài khoản nào với vai trò này.',
  'accounts.pager': 'Phân trang tài khoản',
  'accounts.find': 'Tìm tài khoản',
  'accounts.findIntro': 'Nhập chính xác số điện thoại hoặc email của tài khoản Romi đã đăng ký để cấp vai trò.',
  'accounts.search': 'Tìm',
  'accounts.noRole': 'Chưa có vai trò ở nhà hàng này',
  'accounts.role': 'Vai trò',
  'accounts.branches': 'Chi nhánh',
  'accounts.branchesHint': 'Các chi nhánh người này làm việc.',
  'accounts.restaurantWide': 'Vai trò này bao quát mọi chi nhánh.',
  'accounts.grantNotice': 'Người này sẽ được thông báo.',
  'accounts.grant': 'Cấp vai trò',
  'accounts.saved': 'Đã lưu vai trò.',
  'accounts.edit': 'Sửa',
  'accounts.revoke': 'Gỡ vai trò',
  'accounts.confirmRevoke': 'Xác nhận gỡ',
  'accounts.confirmRevokeOf': 'Xác nhận gỡ vai trò của {name}',
  'accounts.revoked': 'Đã gỡ vai trò.',
  'staff.title': 'Nhân viên',
  'staff.adminOnly': 'Chỉ quản lý chi nhánh này, quản lý nhà hàng và chủ nhà hàng mới được quản lý nhân viên.',
  'staff.findIntro': 'Nhập chính xác số điện thoại hoặc email của tài khoản Romi đã đăng ký để thêm làm nhân viên chi nhánh này.',
  'staff.here': 'Đang là nhân viên của chi nhánh này.',
  'staff.alsoIn': 'Cũng làm ở:',
  'staff.otherRole': 'Tài khoản này giữ vai trò {role}. Hãy quản lý ở trang tài khoản của nhà hàng.',
  'staff.add': 'Thêm vào chi nhánh này',
  'staff.added': 'Đã thêm làm nhân viên chi nhánh này.',
  'staff.remove': 'Gỡ',
  'staff.confirmRemove': 'Xác nhận gỡ',
  'staff.confirmRemoveOf': 'Xác nhận gỡ {name} khỏi chi nhánh này',
  'staff.removed': 'Đã gỡ khỏi chi nhánh này.',
  'staff.empty': 'Chi nhánh này chưa có nhân viên.',
  'staff.pager': 'Phân trang nhân viên',
  'menu.title': 'Thực đơn',
  'menu.managerOnly': 'Chỉ quản lý nhà hàng và chủ nhà hàng mới được sửa thực đơn.',
  'menu.categoriesTitle': 'Danh mục',
  'menu.categoriesHint': 'Khách xem thực đơn theo thứ tự này. Món được liệt kê dưới danh mục của nó ở bên dưới.',
  'menu.noCategories': 'Chưa có danh mục nào. Thêm một danh mục để bắt đầu thực đơn.',
  'menu.addCategory': 'Thêm danh mục',
  'menu.editCategory': 'Sửa danh mục',
  'menu.nameFor': 'Tên ({language})',
  'menu.nameMain': 'Ngôn ngữ chính, bắt buộc',
  'menu.moveUp': 'Chuyển {name} lên',
  'menu.moveDown': 'Chuyển {name} xuống',
  'menu.itemCount': '{count} món',
  'menu.categorySaved': 'Đã lưu danh mục.',
  'menu.categoryDeleted': 'Đã xóa danh mục.',
  'menu.confirmDeleteCategoryOf': 'Xác nhận xóa danh mục {name}',
  'menu.noItems': 'Danh mục này chưa có món nào.',
  'menu.addItem': 'Thêm món',
  'menu.editItem': 'Sửa món',
  'menu.category': 'Danh mục',
  'menu.price': 'Giá',
  'menu.priceIn': 'Tính bằng {currencies}.',
  'menu.priceWhole': 'Chỉ nhập số nguyên.',
  'menu.priceDecimals': 'Tối đa {decimals} chữ số thập phân.',
  'menu.step': 'Bước số lượng',
  'menu.stepHint': 'Cách khách thay đổi số lượng: nguyên phần, nửa phần, hoặc phần mười cho món bán theo cân.',
  'menu.step.whole': 'Nguyên phần (1)',
  'menu.step.half': 'Có nửa phần',
  'menu.step.tenth': 'Theo kg',
  'menu.picture': 'Ảnh',
  'menu.pictureHint': 'Không bắt buộc. Hiển thị dạng vuông. Ảnh JPEG, PNG hoặc WebP tối đa {max_mb} MB.',
  'menu.pictureOf': 'Ảnh của {name}',
  'menu.uploading': 'Đang tải lên…',
  'menu.removePicture': 'Bỏ ảnh',
  'menu.itemSaved': 'Đã lưu món.',
  'menu.itemDeleted': 'Đã xóa món.',
  'menu.confirmDeleteItemOf': 'Xác nhận xóa {name}',
  'branches.title': 'Chi nhánh',
  'branches.hint': 'Mở một chi nhánh để vào trang quản lý của chi nhánh đó.',
  'branches.empty': 'Chưa có chi nhánh nào.',
  'branchMenu.title': 'Thực đơn chi nhánh',
  'branchMenu.adminOnly': 'Chỉ quản lý chi nhánh trở lên mới được sửa thực đơn chi nhánh.',
  'branchMenu.hint':
    'Thực đơn nhà hàng theo cách chi nhánh này phục vụ. Bỏ chọn món khi hết hàng hoặc không bán ở đây; đặt số lượng trong ngày để ngừng nhận đặt khi về 0.',
  'branchMenu.noMenu': 'Nhà hàng chưa có món nào.',
  'branchMenu.available': 'Đang bán',
  'branchMenu.availableFor': 'Đang bán: {name}',
  'branchMenu.unavailable': 'Không bán',
  'branchMenu.soldOut': 'Hết hàng',
  'branchMenu.stockLeft': 'Còn {count}',
  'branchMenu.basePrice': 'Giá gốc {price}',
  'branchMenu.edit': 'Sửa tại chi nhánh này',
  'branchMenu.stock': 'Số lượng trong ngày',
  'branchMenu.stockHint': 'Để trống nếu không theo dõi số lượng. Khi về 0, món hiện là hết hàng và không đặt được.',
  'branchMenu.price': 'Giá tại chi nhánh này',
  'branchMenu.priceHint': 'Để trống để dùng giá gốc ({price}).',
  'branchMenu.priceManagerOnly': 'Chỉ quản lý nhà hàng và chủ nhà hàng mới đổi được giá chi nhánh.',
  'branchMenu.saved': 'Đã lưu.',
  'tables.title': 'Bàn',
  'tables.adminOnly': 'Chỉ quản lý chi nhánh trở lên mới quản lý bàn.',
  'tables.hint':
    'Bàn dùng cho phục vụ tại chỗ theo phiên: mọi đơn quét tại một bàn gộp vào một hóa đơn cho đến khi nhân viên đóng phiên. Nếu khách trả tiền theo từng đơn, không cần tạo bàn — hãy in mã QR mang đi và bật trường địa chỉ giao để khách ghi nơi nhận món.',
  'tables.qrTitle': 'Mã QR',
  'tables.printQr.restaurant': 'In QR nhà hàng',
  'tables.printQr.branch': 'In QR chi nhánh',
  'tables.printQr.take_away': 'In QR mang đi',
  'tables.print': 'In QR',
  'tables.printFor': 'In QR: {name}',
  'tables.listTitle': 'Bàn ăn tại chỗ',
  'tables.empty': 'Chưa có bàn nào.',
  'tables.name': 'Tên bàn',
  'tables.nameHint': 'Tối đa {max} ký tự, không trùng trong chi nhánh.',
  'tables.add': 'Thêm bàn',
  'tables.editFor': 'Sửa: {name}',
  'tables.confirmDeleteOf': 'Xác nhận xóa {name}',
  'tables.code': 'Mã {code}',
  'tables.pager': 'Các trang bàn',
  'tables.saved': 'Đã lưu.',
  'tables.deleted': 'Đã xóa bàn.',
  'queue.title': 'Hàng đợi',
  'queue.filter': 'Trạng thái hiển thị',
  'queue.shopOpen': 'Đang mở',
  'queue.shopClosed': 'Đã đóng',
  'queue.pin': 'Mã PIN đặt món: {pin}',
  'queue.empty': 'Không có đơn nào.',
  'queue.details': 'Chi tiết',
  'queue.next.sent': 'Xác nhận',
  'queue.next.confirmed': 'Bắt đầu làm',
  'queue.next.processing': 'Đã sẵn sàng',
  'queue.next.ready': 'Hoàn tất',
  'queue.moved': 'Đơn này đã ở trạng thái “{status}”. Đang tải lại…',
  'orderDetails.code': 'Mã {code}',
  'orderDetails.notFound': 'Đơn này không thuộc chi nhánh này.',
  'orderDetails.print': 'In',
  'orderDetails.edit': 'Sửa',
  'orderDetails.done': 'Xong',
  'orderDetails.tabs': 'Sửa đơn',
  'orderDetails.tab.return': 'Trả món',
  'orderDetails.tab.weight': 'Cân thực tế',
  'orderDetails.returnHint': 'Món trả được trừ khỏi hóa đơn ở mọi đơn, kể cả đơn đã hoàn tất.',
  'orderDetails.now': 'Hiện tại {quantity}',
  'orderDetails.after': 'Còn lại: {quantity}',
  'orderDetails.returnAmount': 'Số lượng trả của {name}',
  'orderDetails.return': 'Trả',
  'orderDetails.nothingLeft': 'Đã trả hết',
  'orderDetails.weightHint': 'Thay số lượng đã đặt bằng cân nặng bếp cân được.',
  'orderDetails.weight': 'Cân thực tế của {name}',
  'orderDetails.saveWeight': 'Lưu cân nặng',
  'orderDetails.noWeightItems': 'Đơn này không có món bán theo cân.',
  'orderDetails.weightNotActive': 'Chỉ nhập cân thực tế khi đơn còn đang xử lý.',
  'orderDetails.staffCreated': 'Nhân viên tạo cho khách vãng lai.',
  'orderDetails.staffCreatedFor': 'Nhân viên tạo cho một tài khoản khách.',
  'createOrder.title': 'Tạo đơn',
  'createOrder.form': 'Đơn mới',
  'createOrder.type': 'Loại đơn',
  'createOrder.dineIn': 'Tại bàn',
  'createOrder.table': 'Bàn',
  'createOrder.chooseTable': 'Chọn bàn',
  'createOrder.noTables': 'Chi nhánh chưa có bàn. Đơn tại bàn cần một bàn (quản trị viên thêm ở mục Bàn).',
  'createOrder.forCustomer': 'Liên kết tài khoản khách',
  'createOrder.customerHint': 'Không bắt buộc. Số điện thoại hoặc email chính xác của một tài khoản Romi; đơn sẽ hiện trong lịch sử của khách.',
  'createOrder.review': 'Xem lại đơn',
  'createOrder.empty': 'Chưa chọn món nào. Hãy chọn từ thực đơn phía trên.',
  'createOrder.place': 'Đặt đơn',
  'createOrder.placed': 'Đã đặt đơn #{number}.',
  'createOrder.viewOrder': 'Xem đơn',
  'createOrder.viewSession': 'Xem bàn {name}',
  'sessions.title': 'Phiên bàn',
  'sessions.empty': 'Không có phiên nào đang mở.',
  'sessions.orders': '{count} đơn',
  'sessions.active': '{count} đang xử lý',
  'sessions.notFound': 'Phiên này không thuộc chi nhánh này.',
  'sessions.code': 'Mã {code}',
  'sessions.close': 'Đóng phiên',
  'sessions.closeConfirm': 'Đóng phiên ngay',
  'sessions.closeKeep': 'Giữ phiên mở',
  'sessions.closeBlocked': 'Cần hoàn tất hoặc hủy {count} đơn đang xử lý trước.',
  'sessions.closedNotice': 'Phiên này đã đóng.',
  'sessions.changeTable': 'Đổi bàn',
  'sessions.target': 'Bàn mới',
  'sessions.move': 'Chuyển',
  'sessions.noOtherTables': 'Chi nhánh không có bàn khác.',
  'sessions.busy': 'Bàn {name} đang có phiên mở. Gộp hai nhóm khách vào một hóa đơn?',
  'sessions.merge': 'Gộp vào bàn {name}',
  'sessions.closed': 'Đã đóng',
  'search.title': 'Tìm kiếm',
  'search.tabs': 'Tìm gì',
  'search.tab.orders': 'Đơn hàng',
  'search.tab.sessions': 'Phiên bàn',
  'search.or': 'hoặc',
  'search.orderCode': 'Mã đơn',
  'search.sessionCode': 'Mã phiên',
  'search.codeHint': 'Mã 10 ký tự trên liên kết đơn của khách.',
  'search.invalidCode': 'Mã gồm đúng 10 chữ và số.',
  'search.number': 'Số đơn',
  'search.invalidNumber': 'Nhập số đơn trong ngày (1, 2, 3…).',
  'search.date': 'Ngày',
  'search.dateRequired': 'Chọn ngày.',
  'search.time': 'Giờ',
  'search.table': 'Bàn',
  'search.tableRequired': 'Nhập tên bàn.',
  'search.tableHint': 'Đúng tên bàn, như trên phiếu.',
  'search.byCode': 'Tìm theo mã',
  'search.byNumber': 'Tìm theo số đơn',
  'search.byTable': 'Tìm theo bàn',
  'search.noOrder': 'Không có đơn nào khớp.',
  'search.noSessions': 'Không có phiên nào khớp.',
  'stats.title': 'Thống kê',
  'stats.adminOnly': 'Chỉ quản lý chi nhánh trở lên xem được thống kê.',
  'stats.tabs': 'Kỳ thống kê',
  'stats.tab.date': 'Ngày',
  'stats.tab.month': 'Tháng',
  'stats.tab.year': 'Năm',
  'stats.tab.range': 'Khoảng',
  'stats.date': 'Ngày',
  'stats.month': 'Tháng',
  'stats.year': 'Năm',
  'stats.from': 'Từ',
  'stats.to': 'Đến',
  'stats.span': '{from} – {to}',
  'stats.sales': 'Doanh số',
  'stats.salesHint': 'Mọi đơn trừ đơn đã hủy và hết hạn.',
  'stats.orders': '{count} đơn',
  'stats.bestsellers': 'Bán chạy',
  'stats.allItems': 'Tất cả món',
  'stats.allItemsTitle': 'Món theo lượng bán',
  'stats.sold': 'Bán {quantity}',
  'stats.inOrders': 'trong {count} đơn',
  'stats.deletedItem': 'Không còn trong thực đơn',
  'stats.byStatus': 'Đơn theo trạng thái',
  'stats.ordersOfDate': 'Tất cả đơn trong ngày',
  'stats.ordersOfDateTitle': 'Đơn ngày {date}',
  'stats.noOrders': 'Không có đơn nào trong ngày.',
  'stats.orderPages': 'Trang đơn hàng',
  'stats.byCategory': 'Danh mục',
  'stats.byType': 'Loại đơn',
  'stats.type.dine_in': 'Tại bàn',
  'stats.type.take_away': 'Mang đi',
  'stats.count': 'Số đơn',
  'stats.quantity': 'Số lượng',
  'stats.total': 'Tổng',
  'stats.nothingSold': 'Không bán được gì trong kỳ này.',
  'stats.status': 'Trạng thái',
  'stats.allStatuses': 'Tất cả trạng thái',
  'branchSettings.title': 'Cài đặt chi nhánh',
  'branchSettings.adminOnly': 'Chỉ quản lý chi nhánh trở lên mới đổi được cài đặt chi nhánh.',
  'branchSettings.shopTitle': 'Cửa hàng',
  'branchSettings.shopHint':
    'Khách chỉ đặt món được khi cửa hàng đang mở. Mở khi bắt đầu ngày làm việc và đóng khi ngừng nhận đơn.',
  'branchSettings.status.open': 'Đang mở',
  'branchSettings.status.closed': 'Đã đóng',
  'branchSettings.openShop': 'Mở cửa hàng',
  'branchSettings.closeShop': 'Đóng cửa hàng',
  'branchSettings.openConfirm': 'Mở ngay',
  'branchSettings.closeConfirm': 'Đóng ngay',
  'branchSettings.shopOpened': 'Đã mở cửa hàng.',
  'branchSettings.shopClosed': 'Đã đóng cửa hàng.',
  'branchSettings.orderingTitle': 'Đặt món',
  'branchSettings.mode': 'Chế độ đặt món',
  'branchSettings.mode.open': 'Mở — ai cũng đặt được, không cần đăng nhập',
  'branchSettings.mode.login': 'Đăng nhập — khách phải đăng nhập mới đặt được',
  'branchSettings.mode.closed': 'Đóng — khách không đặt món được',
  'branchSettings.modeHint.open':
    'Đơn của khách chưa đăng nhập ở trạng thái Đã gửi cho đến khi bạn xác nhận, và tự hết hạn nếu không ai xác nhận.',
  'branchSettings.modeHint.login':
    'Mỗi khách chỉ được giữ một số đơn đang hoạt động (đã xác nhận, đang làm hoặc sẵn sàng) cùng lúc.',
  'branchSettings.modeHint.closed':
    'Khách quét mã QR sẽ được báo chi nhánh đã tắt đặt món qua QR và được dẫn sang trang chi nhánh. Nhân viên vẫn tạo đơn được.',
  'branchSettings.expiry': 'Hết hạn đơn chưa xác nhận sau (phút)',
  'branchSettings.expiryHint': 'Chống spam: từ 1 đến {max} phút. Mặc định 10.',
  'branchSettings.cap': 'Số đơn đang hoạt động mỗi khách',
  'branchSettings.capHint': 'Chống spam: từ 1 đến {max}. Mặc định 2.',
  'branchSettings.pinGate': 'Yêu cầu mã PIN khi đặt món',
  'branchSettings.pinGateHint':
    'Dành cho chi nhánh chỉ phục vụ khách tại chỗ: nói mã PIN trực tiếp cho khách, người ở nơi khác sẽ không đặt được.',
  'branchSettings.pin': 'Mã PIN đặt món',
  'branchSettings.pinHint': 'Tối đa {max} ký tự. Khách nhập mã này khi đặt món.',
  'branchSettings.deliveryAddress': 'Hỏi khách mang đi nơi nhận món',
  'branchSettings.deliveryAddressHint':
    'Thêm một ô nhập tự do vào đơn mang đi: địa chỉ, quầy, hoặc tên bàn. Dùng khi khách ngồi chung bàn nhưng trả riêng từng đơn; nếu muốn một hóa đơn cho cả bàn, hãy tạo bàn ăn tại chỗ.',
  'branchSettings.saved': 'Đã lưu cài đặt.',
  'branchInfo.title': 'Thông tin chi nhánh',
  'branchInfo.managerOnly': 'Chỉ quản lý và chủ nhà hàng sửa được thông tin chi nhánh.',
  'branchInfo.hint': 'Hiển thị trên trang công khai của chi nhánh và in ở đầu phiếu.',
  'branchInfo.name': 'Tên chi nhánh',
  'branchInfo.address': 'Địa chỉ',
  'branchInfo.phone': 'Số điện thoại',
  'branchInfo.phoneHint': 'Để trống nếu không có số điện thoại.',
  'branchInfo.openingHoursTitle': 'Giờ mở cửa',
  'branchInfo.openingHoursHint': 'Chọn các ngày chi nhánh mở cửa và đặt khung giờ. Tên ngày hiển thị theo ngôn ngữ của khách.',
  'branchInfo.showOpeningHours': 'Hiển thị giờ mở cửa trên trang chi nhánh',
  'openingHours.mode.same': 'Mọi ngày như nhau',
  'openingHours.mode.weekday_weekend': 'Ngày thường / cuối tuần',
  'openingHours.mode.per_day': 'Từng ngày',
  'openingHours.to': 'đến',
  'openingHours.opens': 'mở cửa',
  'openingHours.closes': 'đóng cửa',
  'openingHours.closed': 'nghỉ',
  'day.mon': 'Thứ Hai',
  'day.tue': 'Thứ Ba',
  'day.wed': 'Thứ Tư',
  'day.thu': 'Thứ Năm',
  'day.fri': 'Thứ Sáu',
  'day.sat': 'Thứ Bảy',
  'day.sun': 'Chủ Nhật',
  'branchInfo.announcementTitle': 'Thông báo',
  'branchInfo.announcementHint':
    'Hiển thị trên trang chi nhánh theo ngôn ngữ khách đang xem. Nếu chỉ điền một ngôn ngữ, mọi khách đều thấy ngôn ngữ đó.',
  'branchInfo.announcementFor': 'Thông báo ({language})',
  'branchInfo.saved': 'Đã lưu thông tin chi nhánh.',
  'qr.title': 'In mã QR',
  'qr.print': 'In',
  'qr.back': 'Về trang bàn',
  'qr.missing': 'Không có gì để in. Hãy chọn một mã QR ở trang bàn.',
  'qr.image': 'Mã QR cho {url}',
  'qr.sign.restaurant': 'Quét để xem trang của chúng tôi',
  'qr.sign.branch': 'Quét để xem thực đơn và thông tin',
  'qr.sign.take_away': 'Quét để đặt món mang đi',
  'qr.sign.table': 'Quét để gọi món tại bàn này',
  'order.takeAway': 'Mang đi',
  'order.table': 'Bàn {name}',
  'order.menuEmpty': 'Thực đơn chưa có món nào.',
  'order.categories': 'Danh mục',
  'order.notFound': 'Liên kết đặt món này không hoạt động. Hãy kiểm tra lại hoặc hỏi nhân viên.',
  'order.loginRequired': 'Chi nhánh này yêu cầu khách đăng nhập trước khi đặt món.',
  'order.shopClosed': 'Chi nhánh này hiện đang đóng cửa và không nhận đơn.',
  'order.qrOrderingOff': 'Chi nhánh này đã tắt đặt món qua mã QR. Vui lòng gọi món với nhân viên.',
  'order.branchPage': 'Xem thực đơn trên trang chi nhánh',
  'order.loginToOrder': 'Đăng nhập để đặt món',
  'order.add': 'Thêm',
  'order.addItem': 'Thêm {name}',
  'order.increase': 'Thêm {name}',
  'order.decrease': 'Bớt {name}',
  'order.remove': 'Bỏ {name}',
  'order.removeShort': 'Bỏ',
  'order.quantityOf': 'Số lượng {name}',
  'order.enlarge': 'Xem lớn ảnh {name}',
  'order.close': 'Đóng',
  'order.viewCart': 'Xem đơn',
  'order.itemCount': '{count} món',
  'order.cartTitle': 'Đơn của bạn',
  'order.cartEmpty': 'Chưa có gì. Hãy chọn món từ thực đơn.',
  'order.lineUnavailable': 'Món này hiện không còn. Hãy bỏ ra để tiếp tục.',
  'order.lineNoteAdd': 'Thêm ghi chú',
  'order.lineNote': 'Ghi chú cho {name}',
  'order.lineNotePlaceholder': 'Ít cay, không hành…',
  'order.note': 'Ghi chú cho cả đơn',
  'order.noteHint': 'Dị ứng, mang ra cùng lúc, hay điều gì nhân viên cần biết. Tối đa {max} ký tự.',
  'order.deliveryAddress': 'Mang món đến đâu?',
  'order.deliveryAddressHint': 'Địa chỉ, quầy, hoặc tên bàn của bạn. Tối đa {max} ký tự.',
  'order.pin': 'Mã PIN đặt món',
  'order.pinHint': 'Hỏi nhân viên để lấy mã PIN.',
  'order.expiryHint': 'Đơn chưa xác nhận sẽ hết hạn sau {minutes} phút.',
  'order.total': 'Tổng cộng',
  'order.place': 'Đặt món',
  'myOrders.title': 'Đơn của tôi',
  'myOrders.active': 'Đơn đang xử lý',
  'myOrders.past': 'Đơn đã xong',
  'myOrders.empty': 'Chưa có đơn nào. Quét mã QR ở bàn hoặc quầy mang về của nhà hàng để đặt món.',
  'myOrders.pager': 'Các trang đơn hàng',
  'myOrders.atCounter': 'Đặt tại quầy',
  'myOrders.venueGone': 'Nơi này không còn trên Romi.',
  'track.title': 'Đơn #{number}',
  'track.notFound': 'Liên kết đơn hàng này không dùng được. Hãy kiểm tra lại hoặc hỏi nhân viên.',
  'track.sessionNotFound': 'Liên kết bàn này không dùng được. Hãy kiểm tra lại hoặc hỏi nhân viên.',
  'track.progress': 'Tiến trình đơn hàng',
  'track.status.sent': 'Đã gửi',
  'track.status.confirmed': 'Đã nhận',
  'track.status.processing': 'Đang làm',
  'track.status.ready': 'Sẵn sàng',
  'track.status.completed': 'Hoàn tất',
  'track.status.canceled': 'Đã hủy',
  'track.status.expired': 'Hết hạn',
  'track.statusHint.sent': 'Đang chờ nhân viên xác nhận đơn của bạn.',
  'track.statusHint.confirmed': 'Nhân viên đã nhận đơn của bạn.',
  'track.statusHint.processing': 'Đơn của bạn đang được chuẩn bị.',
  'track.statusHint.ready': 'Đơn của bạn đã sẵn sàng.',
  'track.statusHint.completed': 'Xong rồi. Cảm ơn bạn!',
  'track.statusHint.canceled': 'Đơn này đã bị hủy.',
  'track.statusHint.expired': 'Đơn này không được xác nhận kịp và đã hết hạn. Hãy đặt lại nếu bạn vẫn muốn.',
  'track.expiresIn': 'Hết hạn sau {time} nếu nhân viên chưa xác nhận.',
  'track.expiring': 'Đang hết hạn…',
  'track.live': 'Cập nhật trực tiếp',
  'track.connecting': 'Đang kết nối…',
  'track.updatesPaused': 'Cập nhật trực tiếp tạm dừng. Sẽ tự làm mới định kỳ.',
  'track.note': 'Ghi chú',
  'track.deliveryAddress': 'Giao đến',
  'track.total': 'Tổng cộng',
  'track.column.item': 'Món',
  'track.column.quantity': 'SL',
  'track.column.unitPrice': 'Đơn giá',
  'track.column.amount': 'Thành tiền',
  'track.returned': 'Đã trả {quantity}',
  'track.cancel': 'Hủy đơn',
  'track.cancelConfirm': 'Có, hủy đơn',
  'track.cancelKeep': 'Giữ lại',
  'track.loginToCancel': 'Đăng nhập để quản lý đơn này',
  'track.seeSession': 'Xem tất cả món đã gọi ở bàn {name}',
  'track.sessionTitle': 'Bàn {name}',
  'track.sessionOpenedAt': 'Mở lúc {time}',
  'track.sessionClosedAt': 'Đóng lúc {time}',
  'track.sessionEmpty': 'Bàn này chưa gọi món nào.',
  'track.sessionOrders': 'Các đơn ở bàn này',
  'track.sessionTotal': 'Tổng của bàn',
  'track.mine': 'Của bạn',
  'landing.tagline': 'Quản lý gọi món nhà hàng',
  'landing.notFound': 'Trang này không tồn tại. Hãy kiểm tra lại liên kết.',
  'landing.whatTitle': 'Romi là gì?',
  'landing.what':
    'Romi là dịch vụ quản lý gọi món nhà hàng trực tuyến giúp đưa nhà hàng của bạn lên mạng chỉ trong vài phút. Khách quét mã QR để xem thực đơn và gọi món ngay trên điện thoại, còn nhân viên quản lý hàng đợi bếp, phiên bàn và hoạt động hằng ngày trên một trang quản trị đơn giản.',
  'landing.whyTitle': 'Vì sao nhà hàng chọn Romi',
  'landing.why1.title': 'Gọi món nhanh hơn',
  'landing.why1.body': 'Khách gọi món ngay khi sẵn sàng, không phải chờ gọi nhân viên.',
  'landing.why2.title': 'Giảm sai sót đơn hàng',
  'landing.why2.body': 'Đơn được gửi thẳng từ điện thoại của khách đến bếp, loại bỏ việc ghi tay và nhầm lẫn.',
  'landing.why3.title': 'Giảm tải cho nhân viên',
  'landing.why3.body': 'Nhân viên dành ít thời gian ghi món hơn và tập trung phục vụ khách tốt hơn.',
  'landing.why4.title': 'Thấu hiểu doanh số',
  'landing.why4.body': 'Thống kê tích hợp giúp bạn ra quyết định tốt hơn.',
  'landing.featuresTitle': 'Đầy đủ những gì bạn cần',
  'landing.feature1': 'Tự gọi món qua mã QR',
  'landing.feature2': 'Hàng đợi bếp theo thời gian thực',
  'landing.feature3': 'Đơn tại chỗ và mang đi',
  'landing.feature4': 'Quản lý phiên bàn',
  'landing.feature5': 'Thiết lập thực đơn và bàn dễ dàng',
  'landing.feature6': 'Thống kê và báo cáo doanh số',
  'landing.feature7': 'Nhiều chi nhánh cho mỗi nhà hàng',
  'landing.feature8': 'Hỗ trợ sẵn tiếng Việt và tiếng Anh',
  'landing.feature9': 'Chạy trên mọi điện thoại, không cần cài ứng dụng',
  'landing.howTitle': 'Cách hoạt động',
  'landing.how1.title': 'Khách quét mã QR',
  'landing.how1.body':
    'Quét mã QR tại bàn để dùng tại chỗ, hoặc mã QR mang đi để đặt món mang về. Thực đơn mở ra ngay, không cần cài ứng dụng.',
  'landing.how2.title': 'Xem và gọi món',
  'landing.how2.body': 'Khách chọn món và đặt đơn ngay trên điện thoại.',
  'landing.how3.title': 'Bếp chuẩn bị',
  'landing.how3.body': 'Đơn hiển thị trong hàng đợi bếp theo thời gian thực, sẵn sàng để chế biến.',
  'landing.how4.title': 'Theo dõi đến khi hoàn tất',
  'landing.how4.body': 'Nhân viên theo dõi từng đơn, tại chỗ hoặc mang đi, qua hàng đợi cho đến khi phục vụ xong.',
  'landing.pricingTitle': 'Miễn phí đến hết 31/12/2026',
  'landing.pricingExpected': 'Giá dự kiến sau đó:',
  'landing.pricingPrice': '100đ mỗi đơn',
  'landing.pricingEx1.title': '100 đơn mỗi ngày (khoảng 3.000 đơn mỗi tháng)',
  'landing.pricingEx1.body': 'Chỉ 10.000đ mỗi ngày (khoảng 300.000đ mỗi tháng)',
  'landing.pricingEx2.title': '50 đơn mỗi ngày (khoảng 1.500 đơn mỗi tháng)',
  'landing.pricingEx2.body': 'Chỉ 5.000đ mỗi ngày (khoảng 150.000đ mỗi tháng)',
  'landing.pricingReward': 'Tham gia trước 31/12/2026 để tiếp tục miễn phí đến hết 31/01/2027.',
  'landing.pricingNote': 'Giá chính thức sẽ được công bố vào đầu tháng 12/2026.',
  'landing.startFree': 'Bắt đầu miễn phí',
  'landing.createRestaurant': 'Tạo nhà hàng',
  'landing.contactTitle': 'Đưa Romi đến nhà hàng của bạn',
  'landing.contact':
    'Bạn tự tạo tài khoản và nhà hàng của mình chỉ trong vài phút. Sau đó đội ngũ của bạn tự quản lý thực đơn, bàn cùng các tài khoản nhân viên và quản trị. Có thắc mắc, hoặc cần thêm nhà hàng thứ hai? Hãy liên hệ với chúng tôi.',
  'guide.title': 'Hướng dẫn sử dụng',
  'guide.intro': 'Cách thiết lập và vận hành nhà hàng trên Romi, từng bước một. Mỗi hướng dẫn in được thành PDF.',
  'guide.createRestaurant': 'Tạo nhà hàng',
  'guide.setupRestaurant': 'Cài đặt nhà hàng',
  'guide.setupBranch': 'Cài đặt chi nhánh',
  'guide.branchOperation': 'Vận hành chi nhánh',
  'guide.print': 'In / Lưu PDF',
  'guide.updated': 'Cập nhật lần cuối {date}',
  'landing.guide': 'Hướng dẫn bắt đầu',
  'landing.footer': '© {year} Romi · Bảo lưu mọi quyền.',
  'landing.poweredBy': 'Vận hành bởi Romi',
  'landing.manageRestaurant': 'Quản lý nhà hàng',
  'landing.manageBranch': 'Quản lý chi nhánh',
  'landing.openQueue': 'Mở hàng đợi',
  'landing.branchesTitle': 'Chi nhánh',
  'landing.noBranches': 'Chưa có chi nhánh nào mở cho khách.',
  'landing.allBranches': 'Tất cả chi nhánh của {name}',
  'landing.open': 'Đang mở',
  'landing.closed': 'Đóng cửa',
  'landing.unavailable': 'Nhà hàng này tạm thời không hoạt động.',
  'landing.announcementTitle': 'Thông báo',
  'landing.infoTitle': 'Thông tin chi nhánh',
  'landing.openingHours': 'Giờ mở cửa',
  'landing.address': 'Địa chỉ',
  'landing.phone': 'Điện thoại',
  'landing.menuTitle': 'Thực đơn',
  'landing.menuHint': 'Giá bán tại chi nhánh này.',
  'common.previous': 'Trước',
  'common.next': 'Sau',
  'common.pageRange': '{from}–{to} trong {total}',
  'common.optional': 'không bắt buộc',
  'common.noMatch': 'Không có kết quả.',
  'common.typeToSearch': 'Gõ để tìm',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.loading': 'Đang tải…',
  'common.retry': 'Thử lại',
  'common.back': 'Quay lại',
  'common.edit': 'Sửa',
  'common.delete': 'Xóa',
  'common.confirmDelete': 'Xác nhận xóa',
}
